import React from 'react';

const SupplyList = ({ supplies = [], onDelete, onUpdate, categories = [], onEdit }) => {

  const getCategoryName = (categoryId) => {
    const category = categories.find(cat => cat.id === categoryId);
    return category ? category.name : 'Sin Categoría';
  };

  return (
    <div className="bg-[#F9EFD7] p-4 rounded-lg shadow">
      <h3 className="text-lg font-semibold text-[#3F1907] mb-3">Insumos</h3>

      {(!supplies || supplies.length === 0) ? (
        <p className="text-[#3F1907]">No hay insumos registrados</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-[#58735A]">
            <thead className="bg-[#58735A]">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Nombre</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Unidad</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Cantidad</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Stock Mínimo</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Proveedor</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Marca</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Costo Total</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Costo Unitario</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Categoría</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Acciones</th>
              </tr>
            </thead>

            <tbody className="bg-[#F9EFD7] divide-y divide-[#58735A]">
              {supplies.map((supply) => {
                if (!supply) return null;

                const quantity  = parseFloat(supply.quantity)  || 0;
                const lowStock  = parseFloat(supply.lowStock)  || 0;
                const totalCost = parseFloat(supply.totalCost) || 0;
                const unitCost  = parseFloat(supply.unitCost)  || (quantity > 0 ? totalCost / quantity : 0);

                return (
                  <tr key={supply.id}>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">{supply.name}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">{supply.unit}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">{quantity.toFixed(2)}</td>
                    <td className={`px-4 py-3 whitespace-nowrap text-sm ${supply.isLowStock ? 'text-red-600 font-bold' : 'text-[#3F1907]'}`}>
                      {lowStock.toFixed(2)}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">{supply.supplier}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">{supply.brand}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">${totalCost.toFixed(2)}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">${unitCost.toFixed(2)}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">{getCategoryName(supply.categoryId)}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907] space-x-2">
                      {/* FIX: llama a onEdit del padre para cargar en el form de arriba */}
                      <button
                        onClick={() => onEdit(supply)}
                        className="text-blue-500 hover:text-blue-700 transition duration-200"
                      >
                        Editar
                      </button>
                      <button
                        onClick={() => onDelete(supply.id)}
                        className="text-red-500 hover:text-red-700 transition duration-200"
                      >
                        Eliminar
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SupplyList;